angular.module('unica_feedback.feedback_controllers')

.controller('FeedbackDetailController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	FeedbackListService, FeedbackEditService
) {

	$scope.feedback = null;
	$scope.feedbackReply = '';
	$scope.event_id = $stateParams.event_id;
	$scope.category_id = $stateParams.category_id;
	$scope.feedback_id = $stateParams.id;

	$rootScope.getEvent( $stateParams.event_id );


	$scope.loadFeedback = function() {
		$scope.showLoader();

		FeedbackListService
			.get( $stateParams.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( !data.error ) {
					$scope.feedback = data;
					$scope.feedbackReply = data.reply;
				}
			});
	};


	$scope.editReply = function() {
		$scope.showLoader();

		FeedbackEditService
			.update( $scope.feedback )
			.then(function(data) {
				$scope.hideLoader();

				console.log(data);

				if ( !data.error ) {
					$scope.showSuccessMsg('Stato feedback salvato con successo!', '');
					$scope.feedback = data;
				}
			});
	};

	$scope.openMediaModal = function () {
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalFeedbackMediaInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/feedback-media.html',
			size: 'lg',
			windowClass: 'modal-media'
		});

		modalInstance.result.then(function (data) {
			$scope.showSuccessMsg('Allegato caricato con successo!', '');
			$scope.loadFeedback();
		}, function () { });
	};

	$scope.loadFeedback();

	$scope.downloadMedia = function( id )
	{
		$scope.showNeutralMsg('Avvio download in corso..');
	};

	$scope.removeMedia = function( id )
	{
		$confirm({
			title: 'Sei sicuro di voler rimuovere l\'allegato?',
			text: 'Confermi la rimozione dell\'allegato associato a questo feedback?'
		}).then(function() {

			FeedbackEditService
				.removeMedia( id )
				.then(function(data) {
					$scope.hideLoader();

					if ( !data.error ) {
						$scope.showSuccessMsg('Allegato rimosso con successo!', '');
						$scope.feedback = data;
					}
				});

		}, function() {
			// Cancel
		});

	};

})

.controller('ModalFeedbackMediaInstanceController',
	function (
		$scope, $stateParams, $rootScope, FeedbackEditService, $http,
		$uibModalInstance, getBaseApiURL, Session, Upload
	) {

		$scope.mediaData = {
			files: [],
			infofiles: [],
			progress: 0,
			uploading: 0,
		};

		// $scope.mediaType = mediaType;
		$scope.uploadDone = false;
		$scope.enableUploadAll = 0;

		$scope.addMediaFiles = function(files) {
			files.forEach( function(file) {
				$scope.enableUploadAll++;
				file.progress = 0;
				file.isReady = false;
				file.isUploading = false;
				file.isSuccess = false;
				$scope.mediaData.files.push(file);
				calcolateProgressBar();
			});
		}

		function calcolateProgressBar() {
			var tmpSum = 0;
			$scope.mediaData.files.forEach(function(file) {
				if ( file.progress ) {
					tmpSum += file.progress;
				}
			});
			$scope.mediaData.progress = Math.floor( tmpSum / $scope.mediaData.files.length );
			$scope.$apply();

		}

		$scope.uploadAll = function() {
			for ( i = 0; i < $scope.mediaData.files.length; i++ ) {
				var tmpFile = $scope.mediaData.files[i];
				if ( !tmpFile.isUploading && !tmpFile.isSuccess && tmpFile.isReady ) {
					$scope.uploadItem(i);
				}
			}
		}

		var bucketRegion = "eu-central-1";
		AWS.config.update({
			region: bucketRegion,
		});

		$scope.uploadItem = function(i) {
			//upload file

			FeedbackEditService
				.getPresignedUrlPUT( $stateParams.id, $scope.mediaData.files[i] )
				.then(function(data) {

					var credentials = new AWS.Credentials({
						accessKeyId : data.accessKey,
						secretAccessKey: data.secret,
						sessionToken: data.token
					});

					var service = new AWS.S3({ credentials: credentials });
					var managedUpload = new AWS.S3.ManagedUpload({
						params: {
							Bucket: data.Bucket,
							Key: data.Key,
							Body: $scope.mediaData.files[i]
						},
						service: service
					});
					$scope.mediaData.files[i].awsName = data.Key;
					managedUpload.send();
					managedUpload.promise().then(function () {

						$scope.mediaData.files[i]['progress'] = 100;
						if ( $scope.mediaData.files[i]['isUploading'] ){ //decremento solo se era stato aumentato
							$scope.mediaData.uploading--;
						}
						$scope.mediaData.files[i]['isUploading'] = false;
						$scope.mediaData.files[i]['isSuccess'] = true;

						$scope.enableUploadAll--;
						$scope.uploadDone = true;

						calcolateProgressBar();

						FeedbackEditService
							.saveMedia($stateParams.id, $scope.mediaData.files[i])
							.then(function(ret) {
								if ( $scope.uploadDone ) {
									$uibModalInstance.close();
								} else {
									$uibModalInstance.dismiss('cancel');
								}
							});

					},function(err) {
						console.error(err);
					});

					managedUpload.on('httpUploadProgress', function (progress) {
						if ( !$scope.mediaData.files[i]['isUploading'] ){ //incremento solo la prima volta
							$scope.mediaData.uploading++;
						}
						$scope.mediaData.files[i]['isUploading'] = true;
						//
						$scope.mediaData.files[i]['progress'] =  parseInt((progress.loaded / progress.total) * 100);
						calcolateProgressBar();
					})

				});

		}

		$scope.abortItem = function(i) {
			if ( $scope.mediaData.files[i].upload ) {
				$scope.mediaData.files[i].upload.abort();
				if ( $scope.mediaData.files[i]['isUploading'] ){ //decremento solo se era stato aumentato
					$scope.mediaData.uploading--;
				}
				$scope.mediaData.files[i]['isUploading'] = false;
				$scope.mediaData.files[i].progress = 0;
				calcolateProgressBar();
			}
		};

		$scope.removeItem = function(i) {
			$scope.mediaData.files.splice(i, 1);
		}

		$scope.closeModal = function() {
			if ( $scope.uploadDone ) {
				$uibModalInstance.close();
			} else {
				$uibModalInstance.dismiss('cancel');
			}
		};

		$scope.triggerInput = function() {
			setTimeout(function() {
				document.getElementById('files').click()
			}, 0);
		};

		$scope.showDelete = true;
		if ( sessionStorage.getItem('sub_from_admin_archive') ) {
			sessionStorage.removeItem('sub_from_admin_archive');
			$scope.showDelete = false;
		}

	});
